<template>
  <div class="footer">
    <img :src="grs">
    <p class="mx-3 mx-md-12">Copyright (c) Le Tinte | STYLEM ITALIA S.R.L. All rights reserved.</p>
    <p class="mx-3 mx-md-12">
      <router-link :to="{ name: 'Document', params: { docname: 'informativa-clienti'} }" class="logo-link">
        <span>Informativa Clienti</span> |
      </router-link>
      <router-link :to="{ name: 'Document', params: { docname: 'informativa-fornitori'} }" class="logo-link">
        <span>Informativa Fornitori</span> |
      </router-link>
      <router-link :to="{ name: 'Document', params: { docname: 'privacy-cookie-policy'} }" class="logo-link">
        <span>Privacy and Cookie Policy</span>
      </router-link>
    </p>

  </div>
</template>

<script>
import grs from '@/assets/img/grs.png'

export default {
  data () {
    return {
      grs
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
}

p span,
p {
  color: $c-dark-grey !important;
}

p span {
  text-decoration: underline;
}

img {
  width: 200px;
  height: 120px;
  position: absolute;
  right: 30px;
  bottom: 0;
  display: none;

  @include breakpoint('sm-and-down') {
    position: relative;
    right: auto;
  }
}
</style>
